var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import AddSharp from '@mui/icons-material/AddSharp';
import RemoveSharp from '@mui/icons-material/RemoveSharp';
import { useNotify } from '../../hooks/notificationHook';
var Field = styled(TextField)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type='number'] {\n    -moz-appearance: textfield;\n    text-align: center;\n    min-width: 30px;\n  }\n"], ["\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type='number'] {\n    -moz-appearance: textfield;\n    text-align: center;\n    min-width: 30px;\n  }\n"])));
var QuantityField = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.min, min = _b === void 0 ? 0 : _b, max = _a.max, _c = _a.step, step = _c === void 0 ? 1 : _c, _d = _a.ariaLabel, ariaLabel = _d === void 0 ? 'quantityField' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.outRangeBehavior, outRangeBehavior = _f === void 0 ? {
        max: {
            type: 'disabled',
            message: '',
        },
        min: {
            type: 'disabled',
            message: '',
        },
    } : _f;
    var notify = useNotify();
    var handleChange = React.useCallback(function (ev) {
        var value = parseFloat(ev.target.value);
        if (isNaN(value)) {
            onChange(undefined);
            return;
        }
        if (value < min) {
            value = min;
        }
        else if (value > max) {
            value = max;
        }
        onChange(value);
    }, [onChange, min, max]);
    var handleIncrease = React.useCallback(function () {
        var increasedValue = (value || 0) + step;
        if (outRangeBehavior.max.type === 'alert' && increasedValue > max) {
            notify('error', [outRangeBehavior.max.message]);
            return;
        }
        onChange(increasedValue);
    }, [onChange, value, max, outRangeBehavior, notify]);
    var handleDecrease = React.useCallback(function () {
        var decreasedValue = (value || 0) - step;
        onChange(min > decreasedValue ? min : decreasedValue);
    }, [onChange, value]);
    return (React.createElement(Field, { type: "number", value: value, className: "quantity-field", onChange: handleChange, disabled: disabled, inputProps: { max: max, min: min, step: step, 'aria-label': ariaLabel }, InputProps: {
            startAdornment: (React.createElement(InputAdornment, { position: "start", sx: { margin: '0' } },
                React.createElement(IconButton, { edge: "start", onClick: handleDecrease, disabled: disabled ||
                        (outRangeBehavior.min.type === 'disabled' &&
                            (value || 0) - step < min), size: "small", color: "inherit", sx: {
                        color: 'text.secondary',
                        padding: '0',
                        width: '24px',
                        height: '24px',
                    }, style: { margin: 0 } },
                    React.createElement(RemoveSharp, { sx: { fontSize: '18px' } })))),
            endAdornment: (React.createElement(InputAdornment, { position: "end", sx: { margin: '0' } },
                React.createElement(IconButton, { edge: "end", onClick: handleIncrease, disabled: disabled ||
                        (outRangeBehavior.max.type === 'disabled' &&
                            (value || 0) + step > max), size: "small", color: "inherit", sx: {
                        color: 'text.secondary',
                        padding: '0',
                        width: '24px',
                        height: '24px',
                    }, style: { margin: 0 } },
                    React.createElement(AddSharp, { sx: { fontSize: '18px' } })))),
        }, size: "small" }));
};
export default QuantityField;
var templateObject_1;
